import Server from "../server";
import View from "../framework/view";
import template from "../../pugc/config";
import jQuery from "jquery";
import {DeliveryConfig, OrderCutoff} from "../bo/delivery_config";
import {formToJson, parseDate, renderDate, renderDollars} from "../misc/utils";
import {JsonDate} from "../misc/types";
import {DeliverySampleCostsMap} from "./delivery_sample_costs_map";
import {autocomplete} from "../google/autocomplete";
import Alerts from "../misc/alerts";
import LocalDB from "../misc/localdb";
import {NewEventDatesNotification} from "./wrb";

export class ConfigView extends View {

    static classname = "config-view";

    private readonly server = Server.instance();

    private config? : DeliveryConfig

    private map : DeliverySampleCostsMap = new DeliverySampleCostsMap();

    constructor() {
        super(ConfigView.classname);
        this.refresh();
    }

    protected render0(): JQuery<HTMLElement> {

        const eventDates = LocalDB.instance().get("event_dates");
        const deliveryMapDates = LocalDB.instance().get("delivery_map_dates");

        const renderCutoff = (x: OrderCutoff) => {
            if (x.cutin_time && ! x.cutoff_time) {
                return `From ${x.cutin_time}`;
            } else if (x.cutin_time && x.cutoff_time) {
                return `From ${x.cutin_time} to ${x.cutoff_time}`;
            } else if (! x.cutin_time && x.cutoff_time) {
                return `To ${x.cutoff_time}`;
            } else {
                return "";
            }
        };

        const data = {
            config: this.config,
            renderDate: renderDate,
            renderDollars: renderDollars,
            renderCutoff: renderCutoff,
            map: this.map,
            event_dates: eventDates,
            delivery_map_dates: deliveryMapDates
        };

        const out = this.pug(template, data);

        out.find(".delivery_cost_params").validate({
            rules: {
                dollars_per_km: { "required": true, "number": true },
                dollars_per_minute: { "required": true, "number": true },
                dollars_round: { "required": true, "number": true },
                dollars_min: { "required": true, "number": true },
            }
        });

        this.afterUpdate(() => {
            if (this.elt().data("initted")) {
                return;
            }
            this.elt().data("initted", true);

            this.elt().find("input.datefield").datefield({startDay: 1});

            const address = this.elt().find("input[name='test_address']");
            autocomplete(address[0] as HTMLInputElement).then((autocomplete) => {
                autocomplete.addListener("place_changed", () => {
                    const place = autocomplete.getPlace();
                    const add = place.formatted_address;
                    if (add) {
                        address.val(add);
                        this.testAddress(add);
                    }
                });
            });
        });

        return out;
    }

    refresh() {
        this.server.getDeliveryConfig().then(config => {
            this.config = config;
            this.map.refresh(config);
            this.update();
        });
    }

    addDate() {
        const date = this.elt().find(".disabled_dates input.datefield").val();
        const d = parseDate(date as string);

        if (! this.config || ! d) {
            return;
        }

        this.config.disabled_dates = this.config.disabled_dates || [];
        this.config.disabled_dates.push(d);

        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }

    removeDate(d: JsonDate) {
        if (! this.config || ! this.config.disabled_dates || ! d) {
            return;
        }
        this.config.disabled_dates = this.config.disabled_dates.filter(x => x !== d);
        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }

    addPickupCutoff() {
        const data: any = {};
        const e = this.elt().find(".pickup_cutoffs");
        const date = e.find("input[name='date']").val() as string;
        let earliest = e.find("input[name='cutin']").val() as string;
        let latest = e.find("input[name='cutoff']").val() as string;
        const d = parseDate(date as string);

        earliest = earliest && earliest.trim();
        latest = latest && latest.trim();

        if (! this.config || ! d) {
            return;
        }

        const TIME_RE = RegExp("^[0-9]+:[0-9]{2}$");

        if (earliest && ! earliest.trim().match(TIME_RE)) {
            Alerts.alert(`Bad time format: ${earliest} (should be like 09:00)`);
            return;
        }
        if (latest && ! latest.trim().match(TIME_RE)) {
            Alerts.alert(`Bad time format: ${latest} (should be like 09:00)`);
            return;
        }

        const x : OrderCutoff = {
            order_date: d
        };
        if (earliest) {
            x.cutin_time = earliest;
        }
        if (latest) {
            x.cutoff_time = latest;
        }

        this.config.pickup_cutoffs = this.config.pickup_cutoffs || [];
        this.config.pickup_cutoffs = this.config.pickup_cutoffs.filter(x => x.order_date !== d);
        this.config.pickup_cutoffs.push(x);

        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }

    removePickupCutoff(d: JsonDate) {
        if (! this.config || ! this.config.pickup_cutoffs || ! d) {
            return;
        }
        this.config.pickup_cutoffs = this.config.pickup_cutoffs.filter(x => x.order_date !== d);
        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }

    addDeliveryCutoff() {
        const data: any = {};
        const e = this.elt().find(".delivery_cutoffs");
        const date = e.find("input[name='date']").val() as string;
        let latest = e.find("input[name='cutoff']").val() as string;
        const d = parseDate(date as string);

        latest = latest && latest.trim();

        if (! this.config || ! d) {
            return;
        }

        const TIME_RE = RegExp("^[0-9]+:[0-9]{2}$");

        if (latest && ! latest.trim().match(TIME_RE)) {
            Alerts.alert(`Bad time format: ${latest} (should be like 09:00)`);
            return;
        }

        const x : OrderCutoff = {
            order_date: d
        };
        if (latest) {
            x.cutoff_time = latest;
        }

        this.config.delivery_cutoffs = this.config.delivery_cutoffs || [];
        this.config.delivery_cutoffs = this.config.delivery_cutoffs.filter(x => x.order_date !== d);
        this.config.delivery_cutoffs.push(x);

        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }

    removeDeliveryCutoff(d: JsonDate) {
        if (! this.config || ! this.config.delivery_cutoffs || ! d) {
            return;
        }
        this.config.delivery_cutoffs = this.config.delivery_cutoffs.filter(x => x.order_date !== d);
        this.server.saveDeliveryConfig(this.config).then(() => {
            this.refresh();
        });
    }
    updateDeliveryParams() {

        const form = this.elt().find(".delivery_cost_params");
        if (! form.valid() || ! this.config) {
            return;
        }

        const data : any = {};
        formToJson(form, data);

        const cnt = (this.config.delivery_costs || []).length;

        for (let idx = 0; idx < cnt; idx++) {
            const costs = (this.config.delivery_costs || [])[idx];

            const val = (field: string) => {
                return data[`${field}-${idx}`] || "";
            };

            if ((costs.postcodes || []).indexOf("Default") == -1) {
                costs.postcodes = val("postcodes").split(",").map((x: any) => x.trim());
            }
            costs.delivery_cents_per_km = val("dollars_per_km") * 100;
            costs.delivery_cents_per_minute = val("dollars_per_minute") * 100;
            costs.delivery_round_cents = val("dollars_round") * 100;
            costs.delivery_minimum_cents = val("dollars_min") * 100;
            costs.delivery_base_cents = val("dollars_base") * 100;
        }

        this.map.refresh(this.config);

        const t = this.elt().find(".test_result");
        const add = t.data("address");
        if (add) {
            this.testAddress(add as string);
        }
    }

    addDeliveryCosts() {
        if (! this.config) {
            return;
        }
        this.config.delivery_costs = this.config.delivery_costs || [];
        this.config.delivery_costs.push({
            postcodes: [],
            delivery_cents_per_km: 0,
            delivery_cents_per_minute: 0,
            delivery_round_cents: 0,
            delivery_minimum_cents: 0,
            delivery_base_cents: 0
        });
        this.update(".delivery_cost_params");
    }

    testAddress(address: string) {
        if (! this.config) {
            return;
        }
        const cost_ = this.server.getDeliveryCost(address, this.config);
        cost_.then((cost) => {
            const t = this.elt().find(".test_result");
            const txt = cost.endAddress + " : " + cost.msg;
            t.text(txt);
            t.data("address", cost.endAddress as string);
        });
    }

    saveDeliveryCosts() {
        if (! this.config) {
            return;
        }
        if (! this.config.delivery_costs || this.config.delivery_costs.length == 0) {
            return;
        }

        this.server.saveDeliveryConfig(this.config).then(() => {
            Alerts.alert("Delivery cost parameters saved");
        }).catch((err) => {
            Alerts.alert(err);
        });
    }

    setEventDates(name: string, dates: string) {
        dates = dates ? dates.replace(/ +/, "") : "";
        const eventDates = LocalDB.instance().get(name);
        if (eventDates == dates) {
            return;
        }
        LocalDB.instance().set(name, dates );
        this.notify(new NewEventDatesNotification());
    }
}

View.on(
    "." + ConfigView.classname,
    "click",
    ".disabled_dates .remove",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        const d = jQuery(elt).data("date") as JsonDate;
        that.removeDate(d);
    });
View.on(
    "." + ConfigView.classname,
    "click",
    ".disabled_dates .add",
    function(that: ConfigView, event, elt) {
        that.addDate();
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".pickup_cutoffs .remove",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        const d = jQuery(elt).data("date") as JsonDate;
        that.removePickupCutoff(d);
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".pickup_cutoffs .add",
    function(that: ConfigView, event, elt) {
        that.addPickupCutoff();
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".delivery_cutoffs .remove",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        const d = jQuery(elt).data("date") as JsonDate;
        that.removeDeliveryCutoff(d);
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".delivery_cutoffs .add",
    function(that: ConfigView, event, elt) {
        that.addDeliveryCutoff();
    });
View.on(
    "." + ConfigView.classname,
    "change",
    ".delivery_cost_params input",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        that.updateDeliveryParams();
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".add-costs",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        that.addDeliveryCosts();
    });

View.on(
    "." + ConfigView.classname,
    "click",
    ".save-delivery-costs",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        that.saveDeliveryCosts();
    });
View.on(
    "." + ConfigView.classname,
    "change",
    ".event_dates",
    function(that: ConfigView, event, elt) {
        event.preventDefault();
        const name = jQuery(elt).attr("name") as string;
        const dates = jQuery(elt).val() as string;
        that.setEventDates(name, dates);
    });
